import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";

import { API_PATH } from "@/constants/config";
import { normalizeTenantPublicConfig } from "@/converter/tenantConfig";
import { request } from "@/helper/http";
import { type TenantPublicConfig, type TenantPublicConfigServer } from "@/types/tenantConfig";

export const getTenantPublicConfig = (tenantId: string): Promise<TenantPublicConfigServer> => {
  return request({
    url: API_PATH.TENANT_PUBLIC_CONFIG(tenantId),
    method: "GET",
  });
};

export const tenantConfigApi = createApi({
  reducerPath: "tenantConfigApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["TenantPublicConfig"],
  endpoints: (builder) => ({
    getTenantPublicConfig: builder.query({
      queryFn: async (tenantId: string): Promise<{ data: TenantPublicConfig } | { error: unknown }> => {
        try {
          const data = await getTenantPublicConfig(tenantId);
          return { data: normalizeTenantPublicConfig(data) };
        } catch (error) {
          return { error };
        }
      },
      providesTags: ["TenantPublicConfig"],
    }),
  }),
});

export const { useGetTenantPublicConfigQuery } = tenantConfigApi;
